import AudienceAgeFilter from "../../components/filters/AudienceAgeFilter/AudienceAgeFilter";
import AudienceAgeFilterResult from "../../components/filters/AudienceAgeFilter/AudienceAgeFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import FindAudienceAgeFilter from "./AudienceAgeFilter";

export const audienceAgeGroupsDefinition = defineDescriptionFilter({
    key: "audienceAgeGroups",
    apiCategory: leadsFilterApiCategory.audienceAgeGroups,
    category: leadsFilterCategoryMap.trafficAndEngagement,
    trackingName: "Audience Age",
    titleKey: { key: "si.lead_gen_filters.group.audienceAgeGroups.name" },

    render: ({ description }) => ({
        tooltipText: { key: "si.lead_gen_filters.group.audienceAgeGroups.tooltip" },
        filter: new FindAudienceAgeFilter({
            options: description.audienceAgeGroups,
        }),
        filterView: AudienceAgeFilter,
        filterResultView: AudienceAgeFilterResult,
    }),
});
